<template>
  <li class="text-xl mb-6">
    <a :href="url"  class="hover:underline">
      {{ label }}
    </a>
    <button v-if="submenu" v-on:click="toggle"  class="ml-8" :class="[active ? 'rotate-90' : '']">
      <i class="relative fa-light fa-chevron-right"></i>
    </button>
    <transition name="fade">
    <div v-show="active">
      <slot> </slot>
      <button v-on:click="toggle" class="z-50 absolute top-0 right-0 mr-9 lg:hidden">
        <i class="fa-light fa-chevron-left"></i>
      </button>
    </div>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'MenuItem',
  components: {},
  props: {
    id: String,
    label: String,
    url: String,
    submenu: Boolean,
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
  },
  data() {
    return {
      active: false,
    };
  },
};
</script>